import { IState } from 'legacy/lut/store'

export const selectComposedReportState = (state: IState) => state.partner360.composedReport
